import React from 'react'

const About = () => {
  return (
    <div>
      <h1>hello im about page</h1>
    </div>
  )
}

export default About
